import { Button, Drawer } from "antd";
import close from "./../../../../assets/images/close-outline.svg";
import RestartPopup from "../restartPopup/RestartPopup";
import { useState } from "react";
import { ValidLanguages } from "../../utils/types";
import { LangSpecificMsg } from "../../utils/constants";

const WarningPopup = ({
  show,
  closePopup,
  handleSubmitToDoctor,
  isSubmitLoading,
  selectedLang,
}: any) => {
  const [restartPopup, setRestartPopup] = useState(false);

  const LangSpecificMsgData =
    LangSpecificMsg[(selectedLang as ValidLanguages) || "english"];

  return (
    <Drawer
      placement="bottom"
      onClose={closePopup}
      closeIcon={false}
      open={show}
      height="auto"
      className="rounded-t-2xl overflow-hidden max-w-[450px] mx-auto"
      style={{ margin: "auto" }}
      push={false}
    >
      <div className="flex flex-col h-full">
        <div className="flex justify-between items-center">
          <div className="font-semibold text-lg">
            {LangSpecificMsgData.likeToDo}
          </div>
          <img src={close} alt="close" onClick={closePopup} />
        </div>
      </div>
      <div className="text-base py-2">
        {LangSpecificMsgData.restartConversation}
      </div>
      <section className="flex justify-center flex-col gap-5 mt-6 w-full text-base font-medium tracking-normal leading-loose text-center">
        <button
          className={`flex justify-center overflow-hidden gap-2 self-stretch px-14 py-2 text-indigo-600 bg-white whitespace-nowrap rounded-xl border border-indigo-600 border-solid`}
          aria-label={"Restart from Beginning"}
          onClick={() => setRestartPopup(true)}
        >
          {LangSpecificMsgData.fromBeginning}
        </button>

        <Button
          className={`flex justify-center overflow-hidden gap-2 self-stretch px-14 py-2 text-white bg-indigo-600 whitespace-nowrap rounded-xl border border-indigo-600 border-solid w-full h-[50px] text-base font-medium`}
          aria-label={"Submit to Doctor"}
          onClick={handleSubmitToDoctor}
          loading={isSubmitLoading}
        >
          {LangSpecificMsgData.submitToDoctor}
        </Button>
      </section>
      <RestartPopup
        show={restartPopup}
        closePopup={() => {
          setRestartPopup(false);
          closePopup();
        }}
        handleBack={() => {
          window.history.back();
          // Force reload after small delay to ensure navigation completes
          setTimeout(() => {
            window.location.reload();
          }, 100);
        }}
        selectedLang={selectedLang}
      />
    </Drawer>
  );
};

export default WarningPopup;
